import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/startOfYear/index.js';

var require$$44 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$44 as default };
